import { InputWithLabel } from '@adotel/components'
import { CircularProgress } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { matchSorter } from 'match-sorter'
import { useEffect, useMemo, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { getTranslate } from '../../localization'
import { Channel } from '../../types/channel'
import { StructuredData } from '../../types/rateConnection'
import ExpandableBoxRow from './ExpandableBoxRow'
import ExpandableBoxRowSkeleton from './ExpandableBoxRow.Skeleton'
import useStyles from './styles/ChannelSection.styles'

interface ChannelSectionProps {
  structuredDataChannel: StructuredData[]
  setStructuredDataChannel: React.Dispatch<
    React.SetStateAction<StructuredData[]>
  >
  channelData:
    | {
        channels: Channel[]
      }
    | undefined
  loadingForChannelData: boolean
}

export default function ChannelSection({
  structuredDataChannel,
  setStructuredDataChannel,
  channelData,
  loadingForChannelData
}: ChannelSectionProps) {
  const classes = useStyles()
  const [searchInputValue, setSearchInputValue] = useState<string>('')
  const [filterdStructuredData, setFilterdStructuredData] = useState<
    StructuredData[]
  >([])
  const PAGE_SIZE = 30
  const [numberOfVisibleChannels, setnumberOfVisibleChannels] =
    useState<number>(PAGE_SIZE)

  const populateStructuredData = (channels: Channel[]): StructuredData[] => {
    return channels.map((ch) => {
      let data: StructuredData = {
        id: ch.basicDetails.channelID || '',
        code: ch.basicDetails.channelCode,
        displayCode: ch.basicDetails.displayChannelCode,
        name: ch.basicDetails.name,
        checked: false,
        children: []
      }

      return data
    })
  }

  useEffect(() => {
    if (channelData) {
      const populatedData = populateStructuredData(channelData.channels)
      setStructuredDataChannel(populatedData)
    }
  }, [channelData])

  const newFullListStructuredData = useMemo(() => {
    return searchInputValue
      ? matchSorter(structuredDataChannel, searchInputValue, {
          keys: ['name']
        })
      : structuredDataChannel
  }, [searchInputValue, structuredDataChannel])

  useEffect(() => {
    setFilterdStructuredData(newFullListStructuredData)
  }, [newFullListStructuredData])

  const handleLoadMore = () => {
    setnumberOfVisibleChannels((currentValue) => currentValue + PAGE_SIZE)
  }

  return (
    <div className={classes.root}>
      <div className={classes.searchSection}>
        <InputWithLabel
          placeholder={getTranslate('Search by channel name')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          className={classes.searchInput}
          value={searchInputValue}
          onChange={(e) => setSearchInputValue(e.currentTarget.value)}
        />
      </div>
      <div className={classes.itemsBox}>
        <div className={classes.listView}>
          {loadingForChannelData ? (
            Array(10)
              .fill(' ')
              .map((ele, index) => (
                <ExpandableBoxRowSkeleton key={index + ele} depth={1} />
              ))
          ) : (
            <InfiniteScroll
              pageStart={0}
              loadMore={handleLoadMore}
              hasMore={
                numberOfVisibleChannels < filterdStructuredData.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={false}>
              {filterdStructuredData.length > 0 &&
                filterdStructuredData
                  .slice(0, numberOfVisibleChannels)
                  .map((item: any, index: number) => (
                    <div
                      key={index}
                      className={classes.expandableBoxRowContainer}>
                      <ExpandableBoxRow
                        disabled={(() => {
                          const checkedItems = structuredDataChannel.filter(
                            (ch) => ch.checked
                          )
                          if (checkedItems.length === 1) {
                            return checkedItems[0].code !== item.code
                          }
                          return false
                        })()}
                        data={item}
                        depth={1}
                        structuredData={structuredDataChannel}
                        setStructuredData={setStructuredDataChannel}
                        hideArrowForChannel
                      />
                    </div>
                  ))}
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  )
}
